module.exports = __webpack_public_path__ + "c4d4d3b81b9244ef6fe4de5f77639d13.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/logo_stingraykaraoke.svg
// module id = 427
// module chunks = 0